import jQuery from 'jquery';
let $ = jQuery;

// define EVENTs
import VariantInfo from "HSNDIR/VariantInfo.js";
import "HSNDIR/ProductOptionSelector.js";
import "LIBS/chosen.jquery.js";
import "HSNDIR/ImageSwapper.js";

HSN.BonusBuy = (function ($) {
    /// <signature>
    ///     <summary>Ensemble Detail Page</summary>
    ///     <returns type="BonusBuy" />
    /// </signature>
    "use strict";

    var application;
    var container;
    var buySelectorList = new Array();

    function handleMatrixOptions() {
        function insertRetailPrice(parent) {
            var retailPriceElement = $("<div/>").addClass("product-retail-price");
            $(parent).prepend(retailPriceElement);
        }

        var products = $(".bonus-buy-product", container);
        var matrixSelector = $(".matrix-options > select", products);

        if ($(".mobile").length == 0 && matrixSelector.length) { //matrix select when too many matrix thumbnails to display
            matrixSelector.chosen();
        }

        if (!Modernizr.touchevents) {
            $.each(products, function () {
                // ReSharper disable once WrongExpressionStatement
                var matrixOptions = $(this).find(".matrix-options");
                var productImage = $(this).find("img.main");

                new HSN.ImageSwapper({
                    container: matrixOptions,
                    destinationImage: productImage,
                    triggerSelector: "a",
                    useHover: false,
                    useData: true,
                    followTriggerHref: false
                });
            });
        }

        //Swap price range for specific matrix item price
        $(".matrix-options > a", products).on("click", function (e) {
            e.preventDefault();

            var matrixPriceAmount = $(this).data("price");
            var matrixOldPriceAmount = $(this).data("old-price");
            var matrixRetailPriceAmount = $(this).data("retail-price");
            var matrixRetailPriceLabel = $(this).data("retail-price-label");
            var product = $(this).closest(".bonus-buy-product-info").parent();
            var priceElement = $(".product-price", product);
            var oldPriceElement = $(".product-old-price > del", product);
            var retailPriceElement = $(".product-retail-price", product);

            if (priceElement && matrixPriceAmount) {
                priceElement.text(matrixPriceAmount);
            }
            if (oldPriceElement && matrixOldPriceAmount) {
                oldPriceElement.text(matrixOldPriceAmount);
            }
            if (matrixRetailPriceAmount) { //Only show retail price for matrix option if available
                if (!retailPriceElement.length) {
                    insertRetailPrice($(".product-pricing", product));
                    retailPriceElement = $(".product-retail-price", product);
                }
                var retailPriceString = matrixRetailPriceLabel + " value: " + matrixRetailPriceAmount;
                retailPriceElement.text(retailPriceString);
            }
            else {
                if (retailPriceElement.length) { //Remove retail price if selected product doesnt have it
                    retailPriceElement.text("");
                }
            }

            $(this).siblings().removeClass("selected");
            $(this).addClass("selected");
        });
    }

    function handleOptionsSelect() {
        var addToBagCallback = function (atbButton) {
            return function () {
                if (HSN.Instance().DeviceInformation.IsMobile) {
                    var checkoutUrl = $(atbButton).data("url");

                    HSN.Instance().GetMobileAddedToBagModal().Show(checkoutUrl);

                    getBagItems();
                }
            };
        };

        function bindBuySelector(product) {
            var imageContainer = $(".bonus-buy-product-image", product);
            var optionsContainer = $(".bonus-buy-product-options", product);
            var variantJsonString = $("#json-variants", optionsContainer).html();
            var variants = variantJsonString ? JSON.parse(variantJsonString) : null;
            let variantInfo = new VariantInfo(variants);
            var productOptionsContainer = $(".product-option-selector", product);
            var matrixOptions = $(product).find(".matrix-options");
            var productImage = $(product).find(".bonus-buy-product-image img");

            if (!optionsContainer.length) {
                return;
            }
            // ReSharper disable once ConstructorCallNotUsed
            new HSN.TabPanel(optionsContainer, ".tabs .tab-items a");

            var addToBagProxy = null;
            if ($("body.mobile").length == 0) {
                optionsContainer.find("input.add-to-bag").addClass("button add-to-bag-proxy");
            }

            //initialize after image swapper/zoomer
            var buySelector = new HSN.BuySelector({
                application: application,
                container: optionsContainer,
                windowLocation: window.location,
                imageContainer: imageContainer,
                favoriteLink: $(".favorite-link", product),
                addToBagCallback: addToBagCallback(addToBagProxy || optionsContainer.find("input.add-to-bag")),
                variants: variants,
                variantInfo: variantInfo
            });

            buySelectorList.push(buySelector);

            //Product Option Selector
            var productOptionSelector = new HSN.ProductOptionSelector({
                application: application,
                container: productOptionsContainer,
                imageContainer: imageContainer,
                favoriteLink: $(".favorite-link", product),
                preSelectedWebId: $(".pre_selected_webid", optionsContainer).val(),
                useSimpleMainImage: $(".is_edit_bag_preview", optionsContainer).val(),
                variantInfo: variantInfo
            }).init();

            if (!Modernizr.touchevents) {
                // ReSharper disable once ConstructorCallNotUsed
                new HSN.ImageSwapper({
                    container: matrixOptions,
                    destinationImage: productImage,
                    triggerSelector: "a",
                    useHover: true,
                    useData: true,
                    followTriggerHref: false
                });
            }
        }

        function updateFavorite(product) {
            HSN.Instance()._getFavoriteService().CheckForFavorites(".favorite-link:not(.favorite-queried)");
        }

        var products = $(".bonus-buy-product", container);

        var anyProductHaveOptions = $(".bonus-buy-product-options", products).length > 0;
        if (!anyProductHaveOptions) {
            return;
        }

        $.each(products, function () {
            bindBuySelector(this);
        });

        application.Events.On(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, function (matrixProductId, url, editBagItemId, editBagIdentity) {
            var matrixOption = $(".matrix-options > a[data-id=\"" + matrixProductId + "\"], .matrix-options > .matrix-selector > option[value=" + matrixProductId + "]", container);
            var product = matrixOption.parents(".bonus-buy-product");

            RemoveBuySelectorFromList($(".bonus-buy-product-options", product));

            $.ajax("/bonusbuy/promotionproduct/" + matrixProductId, {
                type: "GET",
                data: {},
                dataType: "html",
                success: function (data) {
                    if (data) {
                        product.fadeOut(function () {
                            $(this).html(data).fadeIn();

                            bindBuySelector(product);

                            bindProductCardSoldOutColorBehavior();

                            handleTooltips();

                            updateFavorite(product);
                        });
                    }
                    HSN.RemoveWait();
                },
                error: function () {
                    HSN.RemoveWait();
                    alert("Unfortunately there was an error attempting to load the select product.");
                }
            });
        });
    }

    function handleProductThumbnailImages() {
        var products = $(".bonus-buy-product-info", container).parent();
        $.each(products, function () {
            // ReSharper disable once WrongExpressionStatement
            // ReSharper disable once ConstructorCallNotUsed
            new HSN.ImageSwapper({
                container: $(this).find(".product-image-thumbnails"),
                destinationImage: $(this).find("img.main"),
                triggerSelector: "a:not(.video)",
                useHover: true,
                useData: false,
                followTriggerHref: false
            });
        });
    }

    function handleProductSwatches() {
        var products = $(".bonus-buy-product-info", container).parent();
        $.each(products, function () {
            // ReSharper disable once WrongExpressionStatement
            // ReSharper disable once ConstructorCallNotUsed
            new HSN.ImageSwapper({
                container: $(this).find(".product-color-swatches"),
                destinationImage: $(this).find("img.main"),
                triggerSelector: "li",
                useHover: true,
                useData: true,
                followTriggerHref: false
            });
        });
    }

    function handleProductThumbnailVideos() {

        container.find(".product-image-thumbnails .video").each(function () {
            var productVideo = new HSN.Template.ProductVideo({
                application: HSN.Instance(),
                container: $(this),
                videoUrls: { httpUrl: $(this).data("httpUrl"), rtmpUrl: $(this).data("rtmpUrl"), androidUrl: $(this).data("androidUrl") },
                videoName: $(this).data("analyticName"),
                assetId: $(this).data("assetid"),
                webpid: $(this).data("productId"),
                backgroundColor: "#000000"
            });
        });
    }

    function handleAddToBag() {
        var addToBagButton = $(".add-to-bag", container);
        addToBagButton.on("click", function () {
            var productId = $(this).data("product-id");
            application.GetProductPreviewOffCanvas().Show(productId);
            return false;
        });
    }

    function handleTooltips() {
        if (!Modernizr.touchevents) {
            HSN.Tooltip($("[data-tooltip]", container));
        }
    }

    function handlePinterestSharing() {
        $(document).ready(function () {
            $("#pin-button-container").click(function () {
                window.cmCreateManualLinkClickTag("/ensemble-pinterest?cm_sp=Social-_-Ensemble-_-Pinterest&cm_re=Social-_-Ensemble-_-Pinterest", "");
            });
        });

        $(window).on("load", function () {
            (function () {
                var po = document.createElement("script");
                po.type = "text/javascript";
                po.async = true;
                po.src = "https://apis.google.com/js/plusone.js";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(po, s);
            })();

            (function () {
                var po = document.createElement("script");
                po.type = "text/javascript";
                po.async = true;
                po.src = "https://assets.pinterest.com/js/pinit.js";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(po, s);
            })();
        });
    }

    function RemoveBuySelectorFromList(buySelectorContainer) {
        var listIndexToRemove;

        $.each(buySelectorList, function (index, obj) {
            if (obj._container.is(buySelectorContainer)) {
                listIndexToRemove = index;
            }
        });

        if ($.isNumeric(listIndexToRemove) && listIndexToRemove > -1) {
            buySelectorList.splice(listIndexToRemove, 1);
        }

        return;
    }

    function bindProductCardSoldOutColorBehavior() {
        $(".bonus-buy-product-options .small-options label").click(function () {
            var opts = $(this).closest(".bonus-buy-product-options");
            var defaultQty = opts.find(".defaultQuantity").val() || 1;

            opts.find(".quantity select").val(defaultQty).change();
            opts.find(".color-soldout").hide();
        });
    }

    function init(config) {
        /// <signature>
        ///     <summary>Initializer</summary>
        ///     <param name="config" type="PlainObject">
        ///         A set of key/value pairs that configure the Ajax request. All settings are
        ///         optional. A default can be set for any option with $.ajaxSetup(). See jQuery.ajax( settings ) below for a
        ///         complete list of all settings.
        ///     </param>
        /// </signature>
        application = config.application;
        container = $(config.container);

        handleMatrixOptions();
        handleProductThumbnailImages();
        handleProductSwatches();
        handleAddToBag();
        handleProductThumbnailVideos();
        handleTooltips();
        handleOptionsSelect();
        bindProductCardSoldOutColorBehavior();

        $(".bonus-buy-product input.add-to-bag").addClass("button add-to-bag-proxy");
    }

    return {
        init: init
    };
})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/HSN/BonusBuy.js